export default __webpack_public_path__ + "static/media/Menu_Waffle_Beanie.c4d8490d.svg";